"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ManagementNotice',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      visible: true
    };
  },
  methods: {
    handleClose: function handleClose() {
      this.visible = false;
      this.$emit('close');
    }
  }
};